import React from 'react';
import {
    GjensidigePrimary,
    GjensidigeSecondary,
    GjensidigeSymbol
} from '@gjensidige/builders-icons/logos';
import { Flex } from '@gjensidige/builders-components';
import { fetchGenericIllustrations, IllustrationType } from '@gjensidige/se-content-helpers';


export const LogoComponent = ({ logo }: { logo: string }) => {

    const renderLogo = () => {
        switch (logo) {
            case 'GjensidigePrimary':
                return <GjensidigePrimary width="250px" />;
            case 'GjensidigeSecondary':
                return <GjensidigeSecondary width="200px" height="200px" />;
            case 'GjensidigeSymbol':
                return <GjensidigeSymbol width="100px" height="100px" />;
            case 'GjensidigeForsakring':
                return <img
                    alt="gjensidige-logo"
                    className="logo-illustration"
                    src={fetchGenericIllustrations(
                        'GjensidigeForsakring',
                        IllustrationType.DETAILED,
                        [{
                            "name": "GjensidigeForsakring",
                            "filename": "GjensidigeForsakring",
                            "fileType": "svg"
                        }]
                    )}
                ></img>;
            default:
                return <GjensidigePrimary width="250px" />;
        }
    }
    return (
        <Flex center="xxl" className="logo-wrapper">
            {renderLogo()}
        </Flex>
    );
}